<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Mã chỉ tiêu" placeholder="Tìm theo mã chỉ tiêu" v-model="modelSearch.maChiTieu"
                                :isRequire=false @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên chỉ tiêu" placeholder="Tìm theo tên chỉ tiêu" v-model="modelSearch.tenChiTieu"
                                :isRequire=false @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheSelect title="Tháng" :options="category_sKY" :initialValue="modelSearch.idKy"
                                    :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                    @onChange="(e) => { modelSearch.idKy = e ? e : null; handlePageChange(1) }"/>
                            </div>
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <!-- <TheExportExcelButton v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        :onClickParent="exportExcelBaocaoKtxh" :headerExport="headerExport"
                                        :params="modelSearch" fileName="Export_KTXH">
                                    </TheExportExcelButton> -->
                                    <a v-if="currentSearchType == typeDataList.CURRENT_LIST.id" class="dropdown-item text-green" href="#" @click="showExportModal()" :title="$t('buttons.exportExcel')">
                                        <i class="fas fa-file-export"></i>&nbsp;&nbsp;{{ $t('buttons.exportExcel')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.IMPORT_EXCEL" :onClick="showImportModal"
                                        :isDivider="false">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor" style="width:5%" @click="handleSortChange('baocaoKtxhId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'baocaoKtxhId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">STT báo cáo</th>
                                    <th class="col-1 cursor" style="min-width: 100px;" @click="handleSortChange('ten')" title="Sắp xếp theo mã chỉ tiêu">
                                        Mã chỉ tiêu
                                        <span v-if="sortBy == 'ten'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" style="min-width: 100px;" @click="handleSortChange('ten')" title="Sắp xếp theo tên chỉ tiêu">
                                        Tên chỉ tiêu
                                        <span v-if="sortBy == 'ten'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-1 cursor" style="min-width: 100px;" @click="handleSortChange('tenKy')" title="Sắp xếp theo tên ngân hàng">
                                        Tháng
                                        <span v-if="sortBy == 'tenKy'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col">Đơn vị tính</th>
                                    <th class="col">Thực hiện năm trước</th>
                                    <th class="col">Kế hoạch năm</th>
                                    <th class="col">Thực hiện tháng</th>
                                    <th class="col">Thực hiện tháng so với kế hoạch</th>
                                    <th class="col">So với cùng kỳ năm trước</th>
                                    <th class="col">Thực hiện lũy kế đến tháng báo cáo</th>
                                    <th class="col">Ước thực hiện tháng kế tiếp</th>
                                    <th class="col">Ước thực hiện lũy kế</th>
                                    <th class="col">Ước thực hiện lũy kế so với kế hoạch</th>
                                    <th class="col-1 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.baocaoKtxhId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.baocaoKtxhId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td> {{ item.baocaoKtxhId }}</td>
                                    <td> {{ item.sttBaocao }} </td>
                                    <td> {{ item.maChiTieu }} </td>
                                    <td> {{ item.tenChiTieu }} </td>
                                    <td> {{ item.tenKy }} </td>
                                    <td> {{ item.donViTinh }} </td>
                                    <td> {{ item.thucHienNamTruoc }} </td>
                                    <td> {{ item.keHoachNam }} </td>
                                    <td> {{ item.thucHienThang }} </td>
                                    <td> {{ item.thucHienThangSoVoiKeHoach }} </td>
                                    <td> {{ item.soVoiCungKyNamTruoc }} </td>
                                    <td> {{ item.thucHienLuyKeDenThangBc }} </td>
                                    <td> {{ item.uocThucHienThangKeTiep }} </td>
                                    <td> {{ item.uocThucHienLuyKe }} </td>
                                    <td> {{ item.uocThucHienLuyKeSoVoiKeHoach }} </td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.baocaoKtxhId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass=" modal-80vw" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
                <div class="col-md-3">
                        <TheInputText title="STT báo cáo" placeholder="Nhập STT báo cáo" :initialValue="model.sttBaocao" v-model="model.sttBaocao"
                            :error="errors.sttBaocao" :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                            :key="tempKey" />
                    </div>
                    <div class="col-md-3">
                        <TheInputText title="Mã chỉ tiêu" placeholder="Nhập mã chỉ tiêu" :initialValue="model.maChiTieu" v-model="model.maChiTieu"
                            :error="errors.maChiTieu" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                            :key="tempKey" />
                    </div>
                    <div class="col-md-3">
                        <TheSelect title="Tháng" :options="category_cKY" :initialValue="model.idKy"
                            :error="errors.idKy" :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                            :isRequire="true" @onChange="(e) => { model.idKy = e }" :key="tempKey" />
                    </div>
                    <div class="col-md-3">
                        <TheInputText title="Đơn vị tính" placeholder="Nhập đơn vị tính" :initialValue="model.donViTinh" v-model="model.donViTinh"
                            :error="errors.donViTinh" :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                            :key="tempKey" />
                    </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                        <TheInputText title="Tên chỉ tiêu" placeholder="Nhập tên chỉ tiêu" :initialValue="model.tenChiTieu" v-model="model.tenChiTieu"
                            :error="errors.tenChiTieu" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                            :key="tempKey" />
                    </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Thực hiện năm trước" placeholder="Nhập thực hiện năm trước" :initialValue="model.thucHienNamTruoc"
                            v-model="model.thucHienNamTruoc" :error="errors.thucHienNamTruoc" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Kế hoạch năm" placeholder="Nhập Kế hoạch năm" :initialValue="model.keHoachNam"
                        v-model="model.keHoachNam" :error="errors.keHoachNam" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Thực hiện tháng" placeholder="Nhập Thực hiện tháng" :initialValue="model.thucHienThang"
                        v-model="model.thucHienThang" :error="errors.thucHienThang" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                        <TheInputText title="Thực hiện tháng so với kế hoạch năm" placeholder="Nhập thực hiện tháng so với kế hoạch năm" :initialValue="model.thucHienThangSoVoiKeHoach"
                            v-model="model.thucHienThangSoVoiKeHoach" :error="errors.thucHienThangSoVoiKeHoach" :isReadOnly="isReadOnly" :isRequire=false
                            :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="So với cùng kỳ năm trước" placeholder="Nhập so với cùng kỳ năm trước" :initialValue="model.soVoiCungKyNamTruoc"
                        v-model="model.soVoiCungKyNamTruoc" :error="errors.soVoiCungKyNamTruoc" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Thực hiện lũy kế đến tháng báo cáo" placeholder="Nhập thực hiện lũy kế đến tháng báo cáo" :initialValue="model.thucHienLuyKeDenThangBc"
                        v-model="model.thucHienLuyKeDenThangBc" :error="errors.thucHienLuyKeDenThangBc" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Ước thực hiện tháng kế tiếp" placeholder="Nhập ước thực hiện tháng kế tiếp" :initialValue="model.uocThucHienThangKeTiep"
                        v-model="model.uocThucHienThangKeTiep" :error="errors.uocThucHienThangKeTiep" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Ước thực hiện lũy kế" placeholder="Nhập ước thực hiện lũy kế" :initialValue="model.uocThucHienLuyKe"
                        v-model="model.uocThucHienLuyKe" :error="errors.uocThucHienLuyKe" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Ước thực hiện lũy kế so với kế hoạch" placeholder="Nhập Ước thực hiện lũy kế so với kế hoạch" :initialValue="model.uocThucHienLuyKeSoVoiKeHoach"
                        v-model="model.uocThucHienLuyKeSoVoiKeHoach" :error="errors.uocThucHienLuyKeSoVoiKeHoach" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="false" :key="tempKey" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                        v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                        :isMultipleLine="true" :key="tempKey" />
                </div>
            </div>
        <div class="row">
            <div class="col-md-6">
                <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt" v-model="model.stt"
                    :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-6">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
    </TheCRUDFrameModal>
    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=" modal-lg"
        :headerTitle="$t('labels.itemDetails')" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row" v-if="modelRec && modelRec.hinhAnh">
            <div class="container mt-3 mb-3 p-1 d-flex justify-content-center">
                <div class=" image d-flex flex-column justify-content-center align-items-center">
                    <img :src="modelRec.linkHinhAnh" height="150" />
                </div>
            </div>
        </div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.baocaoKtxhId }}&nbsp;</b>
                </p>
                <p class="text-sm">STT báo cáo:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sttBaocao }}&nbsp;</b>
                </p>
                <p class="text-sm">Mã chỉ tiêu:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.maChiTieu }}&nbsp;</b>
                </p>
                <p class="text-sm">Tên chỉ tiêu:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenChiTieu }}&nbsp;</b>
                </p>
                <p class="text-sm">Tháng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKy }}&nbsp;</b>
                </p>
                <p class="text-sm">Đơn vị tính:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.donViTinh }}&nbsp;</b>
                </p>
                <p class="text-sm">STT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                </p>
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-4 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Thực hiện năm trước:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienNamTruoc }}&nbsp;</b>
                </p>
                <p class="text-sm">Kế hoạch năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.keHoachNam }}&nbsp;</b>
                </p>
                <p class="text-sm">Thực hiện tháng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienThang }}&nbsp;</b>
                </p>
            </div>
            <div class="col-4 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Thực hiện tháng so với kế hoạch:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienThangSoVoiKeHoach }}&nbsp;</b>
                </p>
                <p class="text-sm">So với cùng kỳ năm trước:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soVoiCungKyNamTruoc }}&nbsp;</b>
                </p>
                <p class="text-sm">Thực hiện lũy kế đến tháng Báo cáo:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienLuyKeDenThangBc }}&nbsp;</b>
                </p>
            </div>
            <div class="col-4 col-md-4 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Ước thực hiện tháng kế tiếp:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.uocThucHienThangKeTiep }}&nbsp;</b>
                </p>
                <p class="text-sm">Ước thực hiện lũy kế:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.uocThucHienLuyKe }}&nbsp;</b>
                </p>
                <p class="text-sm">Ước thực hiện lũy kế so với kế hoạch:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.uocThucHienLuyKeSoVoiKeHoach }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
            </div>
        </div>
    </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>

    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>

    <TheImportModal :title="import_GetFileModel.title"
        :confirmLabelButton="import_GetFileModel.confirmLabelButton" :onClose="import_GetFileModel.onClose"
        :onSubmit="import_GetFileModel.onSubmit" :filename="import_GetFileModel.filename"
        :acceptFile="import_GetFileModel.acceptFile" :columnConfig="dataImportConfig"
        v-model:showModalFlag="isShowModal.importModal" v-model:dataReturn="import_GetFileModel.dataReturn" :customsSlotCheck="import_GetFileModel.customsSlotCheck"
        :rowBegin="1">
        <div class="row">
            <TheSelect title="Tháng" :options="category_cKY" :initialValue="kyValueImport"
                :error="kyValueImportError" :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                :isRequire="true" @onChange="(e) => { kyValueImport = e }" :key="tempKey" />
        </div>
    </TheImportModal>

    <div class="modal fade" id="exportModal" data-keyboard="false" data-backdrop="static">
        <loading id="exportLoading" :active="loadingSubmit" class="text-center" color="#000000" loader="spinner"></loading>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">Xuất dữ liệu báo cáo Kinh tế Xã hội</h4>
                </div>
                <div class="modal-body modal-body-customs">
                    <div class="row">
                        <div class="col-md-12">
                            <TheSelect title="Tháng" 
                                :options="category_sKY" :initialValue="modelSearch.idKy" :error="errorsExport.idKy"
                                :isMultiple="false" :isAllowClear="true" :isRequire="true" :key="tempKey"
                                @onChange="(e) => { modelExport.idKy = e ? e : null;}"/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="closeExportModal">&nbsp;Đóng</button>
                    <button type="button" class="pull-right btn btn-outline-primary" @click="onExportSubmit">&nbsp;Xuất báo cáo</button>
                </div>

            </div>
        </div>
    </div>

</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import tableValue from '@/config/table.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import TheExportExcelButton from '@/components/shareComponents/table/button/TheExportExcelButton.vue'
import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'

import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'
import TheImportModal from '@/components/shareComponents/modal/TheImportModal.vue'

import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { baocaoKtxhModel } from '@/models/taichinhkehoach/baocaoKtxh.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "TheBaoCaoKTXH",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSwapButton,
        TheCreateButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheExportExcelButton,
        TheImportModal,
        TheSwitchButton,
        TheSwitchInTable

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: baocaoKtxhModel.newModel(),
            model: baocaoKtxhModel.newFEModel(),
            errors: baocaoKtxhModel.errors(),
            modelExport: baocaoKtxhModel.newExportModel(),
            errorsExport: baocaoKtxhModel.errorsExport(),
            modelSearch: baocaoKtxhModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_cKY: [],
            category_sKY: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),


            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
                importModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

            kyValueImport: null,
            kyValueImportError: "",



            dataImportConfig: [
                { name: "sttBaoCao", columnTitle: "Số thứ tự Báo cáo", columnIndex: 0, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "maChiTieu", columnTitle: "Mã chỉ tiêu", columnIndex: 1, typeData: objectDefaultValue.handleData.STRING, required: true },
                { name: "tenChiTieu", columnTitle: "Tên chỉ tiêu", columnIndex: 2, typeData: objectDefaultValue.handleData.STRING, required: true },
                { name: "donViTinh", columnTitle: "Đơn vị tính", columnIndex: 3, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "thucHienNamTruoc", columnTitle: "Thực hiện năm trước", columnIndex: 4, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "keHoachNam", columnTitle: "Kế hoạch năm", columnIndex: 5, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "thucHienThang", columnTitle: "Thực hiện tháng", columnIndex: 6, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "thucHienThangSoVoiKeHoach", columnTitle: "Thực hiện tháng so với kế hoạch năm", columnIndex: 7, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "soVoiCungKyNamTruoc", columnTitle: "So với cùng kỳ năm trước", columnIndex: 8, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "thucHienLuyKeDenThangBc", columnTitle: "Thực hiện lũy kế đến tháng BC", columnIndex: 9, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "uocThucHienThangKeTiep", columnTitle: "Ước thực hiện tháng kế tiếp", columnIndex: 10, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "uocThucHienLuyKe", columnTitle: "Ước thực hiện lũy kế", columnIndex: 11, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "uocThucHienLuyKeSoVoiKeHoach", columnTitle: "Ước thực hiện lũy kế so với kế hoạch", columnIndex: 12, typeData: objectDefaultValue.handleData.STRING, required: false },
                { name: "ghiChu", columnTitle: "Ghi chú", columnIndex: 13, typeData: objectDefaultValue.handleData.STRING, required: false },
            ],
            import_GetFileModel: {
                title: '',
                confirmLabelButton: '',
                onClose: null,
                onSubmit: null,
                filename: '',
                acceptFile: null,
                dataReturn: [],
            },
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('baocaoKtxh', ['getPagingBaocaoKtxh', 'getDetailBaocaoKtxh', 'checkExistBaocaoKtxh', 'createBaocaoKtxh', 'updateBaocaoKtxh', 'deleteBaocaoKtxh', 'restoreBaocaoKtxh', 'handleListBaocaoKtxh', 'setEnabledBaocaoKtxh', 'exportExcelBaocaoKtxh', 'getMapInfoBaocaoKtxh', 'importExcelBaocaoKtxh']),
        ...mapActions('dmKy', ['getBasicDMKy']),
        async setup() {
            let header = 'Danh sách Báo cáo Kinh tế xã hội'
            this.setupHeader({ header })
        },

        async initialize() {
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                baocaoKtxhId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledBaocaoKtxh({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.baocaoKtxhId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.baocaoKtxhId === this.cEnable_Item.baocaoKtxhId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },


        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.baocaoKtxhId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            this.category_sKY = await this.getCategory_Ky(1)
            await this.getPagingBaocaoKtxh({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = baocaoKtxhModel.errors()
            this.category_cKY = await this.getCategory_Ky()

            this.loadingSubmit = false

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    baocaoKtxhId: item.baocaoKtxhId
                }
                await this.getDetailBaocaoKtxh({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = baocaoKtxhModel.newModel()
                        this.modelRec = resp
                        this.model = baocaoKtxhModel.parseModeltoFEModel(this.modelRec)
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    baocaoKtxhId: item.baocaoKtxhId
                }
                await this.getDetailBaocaoKtxh({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = baocaoKtxhModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = baocaoKtxhModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistBaocaoKtxh({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = baocaoKtxhModel.errors()
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }
            if (!await this.validateRequired(model.maChiTieu)) {
                this.errors.maChiTieu = "Nhập mã chỉ tiêu"
                isvalid = false
            }

            if (!await this.validateRequired(model.tenChiTieu)) {
                this.errors.tenChiTieu = "Nhập tên chỉ tiêu"
                isvalid = false
            }

            if (!await this.validateRequired(model.idKy)) {
                this.errors.idKy = "Cần phải chọn tháng báo cáo"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = baocaoKtxhModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.baocaoKtxhId = FEmodel.baocaoKtxhId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.baocaoKtxhId = FEmodel.baocaoKtxhId
                sendModel.sttBaocao = FEmodel.sttBaocao
                sendModel.maChiTieu = FEmodel.maChiTieu
                sendModel.tenChiTieu = FEmodel.tenChiTieu
                sendModel.donViTinh = FEmodel.donViTinh
                sendModel.thucHienNamTruoc = FEmodel.thucHienNamTruoc
                sendModel.keHoachNam = FEmodel.keHoachNam
                sendModel.thucHienThang = FEmodel.thucHienThang
                sendModel.thucHienThangSoVoiKeHoach = FEmodel.thucHienThangSoVoiKeHoach
                sendModel.soVoiCungKyNamTruoc = FEmodel.soVoiCungKyNamTruoc
                sendModel.thucHienLuyKeDenThangBc = FEmodel.thucHienLuyKeDenThangBc
                sendModel.uocThucHienThangKeTiep = FEmodel.uocThucHienThangKeTiep
                sendModel.uocThucHienLuyKe = FEmodel.uocThucHienLuyKe
                sendModel.uocThucHienLuyKeSoVoiKeHoach = FEmodel.uocThucHienLuyKeSoVoiKeHoach
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.idKy = FEmodel.idKy
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false



            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createBaocaoKtxh({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateBaocaoKtxh({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteBaocaoKtxh({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteBaocaoKtxh({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreBaocaoKtxh({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListBaocaoKtxh(modelSend)
            }
            else {
                res = await this.handleListBaocaoKtxh(modelSend)
            }

            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation
        //#region ImportData

        async showExportModal() {
            this.modelExport = baocaoKtxhModel.newExportModel()
            this.errorsExport = baocaoKtxhModel.errorsExport()
            this.tempKey = common.randomString(10)
            $('#exportModal').modal('show');
        },
        closeExportModal() {
            $('#exportModal').modal('hide');
        },

        async onExportSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let res = false
            this.errorsExport = baocaoKtxhModel.errorsExport()
            let isvalid = true
            if (!await this.validateRequired( this.modelExport.idKy)) {
                this.errorsExport.idKy = "Cần phải chọn tháng báo cáo"
                isvalid = false
            }
            if (isvalid) {
                let tempSendData = this.modelExport
                res = await this.exportExcelBaocaoKtxh({ params: tempSendData })
            }

            this.loadingSubmit = false
        },

        async showImportModal() {
            this.import_GetFileModel = {
                title: "Import",
                confirmLabelButton: "Đọc dữ liệu file",
                onClose: null,
                onSubmit: this.onConfirmImportSubmit,
                customsSlotCheck: this.validateImport,
                filename: "BCKTXH_ImportSample.xlsx",
                acceptFile: this.acceptTypeExcel,
                dataReturn: [],
            }
            console.log(this.import_GetFileModel)
            this.category_cKY = await this.getCategory_Ky()
            this.kyValueImport = null
            this.isShowModal.importModal = true
        },

        async onConfirmImportSubmit() {
            let listData = []
            for (const element of this.import_GetFileModel.dataReturn) {
                let tempValue = Object()
                for (let key in element.data) {
                    if (element.data[key].value != "")
                        tempValue[key] = element.data[key].value
                }
                listData.push(tempValue);
            }
            for (let i = 0; i < listData.length; i++) {
                listData[i].stt = i+1 + ""
                listData[i].idKy = this.kyValueImport
            }
            let importPush = {
                listData: listData,
            };
            let result = await this.importExcelBaocaoKtxh({ item: importPush })
            this.isShowModal.importModal = false
            if (result === true)
                await this.getData();

        },

        async validateImport() {
            let isvalid = true

            if (!await this.validateRequired(this.kyValueImport)) {
                this.kyValueImportError = "Cần phải chọn tháng báo cáo"
                isvalid = false
            }
            else {
                this.kyValueImportError = null
            }
            return isvalid
        },


        //#endregion ImportData
        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.TCKH_BAOCAOKTXH,
                loaiKy: 'M'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },

    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
